import { CreateListSupplierEmployee, UploadSupplierEmployeeFormFile } from "../../../reduxToolkit/Files/FilesApi"; // API calls for uploading files and creating supplier employee records
import { toast } from "react-toastify"; // Library for toast notifications
import routes from "../../../Routes/routes";
import {errorMsg} from "../../../Apis/functions"; // Application route definitions

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

/**
 * Component logic for handling file upload and creation of supplier employee records.
 *
 * @param {function} t - Translation function (i18next).
 * @param {function} dispatch - Redux dispatch function.
 * @param {function} navigate - Navigation function to change routes.
 * @param {object} spreadsheetData - Parsed spreadsheet data, used to check if a file is loaded.
 * @param {object} data - Data object containing supplier employee information to be created.
 * @param {function} setUpdate - Function to trigger a UI update or state refresh.
 * @param {function} getFormData - Function that returns form data (typically including the file to upload).
 * @param {function} isValidFile - Callback executed after successful file upload validation.
 */
export const CreationErrorsSupplierEmployeeApp = ({
                                                      t,
                                                      dispatch,
                                                      navigate,
                                                      spreadsheetData,
                                                      data,
                                                      setUpdate,
                                                      getFormData,
                                                      isValidFile
                                                  }) => {

    // Handles uploading the supplier employee file
    const handleUploadFile = () => {
        setUpdate(true); // Trigger UI update

        // Only attempt upload if spreadsheet data exists
        if (spreadsheetData) {
            const formData = getFormData(); // Retrieve the form data (including file)

            if (formData) {
                dispatch(UploadSupplierEmployeeFormFile(formData)) // Dispatch upload action
                    .then(({ payload: { data: { data, success } } }) => {
                        if (success === true) {
                            isValidFile(data); // Call callback function on successful upload
                        }
                    })
                    .catch(() => {
                        // Show error toast if upload fails
                        toast.error(t('fail_to_upload_file').toUpperCase());
                    });
            }
        } else {
            // Show warning toast if no file is selected
            toast?.warn(t('there_is_not_file_to_upload').toUpperCase());
        }
    };

    // Handles confirmation and creation of supplier employee records
    const handleConfirm = () => {
        dispatch(CreateListSupplierEmployee(data)).then(({ payload: { data: { success, code} } }) => {
            if (success === true) {
                toast.success(t('has_been_created_successfully')); // Show success notification
                navigate(routes.suppliers.employees); // Navigate to supplier employees listing page
            } else errorMsg(code)
        });
    };

    // Return the handlers for use in UI components
    return {
        handleConfirm,
        handleUploadFile
    };
};

// Export the component logic for use in other parts of the application
export default CreationErrorsSupplierEmployeeApp;
